import styled, { css } from 'styled-components/macro';
import { ANIMATION_DURATION, CELL_SIZE } from './app-loader.constants';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100dvw;
    height: 100dvh;
    background-color: ${theme.semantic.loader.bg};

    .loader {
      position: relative;
      display: inline-block;
      width: ${CELL_SIZE}px;
      height: ${CELL_SIZE}px;
    }
    .loader::before {
      content: '';
      box-sizing: border-box;
      width: ${CELL_SIZE / 2}px;
      height: ${CELL_SIZE / 2}px;
      position: absolute;
      left: 0;
      top: -${CELL_SIZE / 2}px;
      animation: animloader ${ANIMATION_DURATION}ms ease infinite;
    }
    .loader::after {
      content: '';
      box-sizing: border-box;
      position: absolute;
      left: 0;
      top: 0;
      width: ${CELL_SIZE / 2}px;
      height: ${CELL_SIZE / 2}px;
      background: ${theme.semantic.loader.indicator};
      animation: animloader2 ${ANIMATION_DURATION / 2}ms ease infinite;
    }

    @keyframes animloader {
      0% {
        box-shadow:
          0 ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE}px transparent,
          0px ${CELL_SIZE}px transparent;
      }
      12% {
        box-shadow:
          0 ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE}px transparent,
          0px ${CELL_SIZE}px transparent;
      }
      25% {
        box-shadow:
          0 ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE}px transparent,
          0px ${CELL_SIZE}px transparent;
      }
      37% {
        box-shadow:
          0 ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE}px ${theme.semantic.loader.trail},
          0px ${CELL_SIZE}px transparent;
      }
      50% {
        box-shadow:
          0 ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE}px ${theme.semantic.loader.trail},
          0px ${CELL_SIZE}px ${theme.semantic.loader.trail};
      }
      62% {
        box-shadow:
          0 ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px ${theme.semantic.loader.trail},
          ${CELL_SIZE / 2}px ${CELL_SIZE}px ${theme.semantic.loader.trail},
          0px ${CELL_SIZE}px ${theme.semantic.loader.trail};
      }
      75% {
        box-shadow:
          0 ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE}px ${theme.semantic.loader.trail},
          0px ${CELL_SIZE}px ${theme.semantic.loader.trail};
      }
      87% {
        box-shadow:
          0 ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE}px transparent,
          0px ${CELL_SIZE}px ${theme.semantic.loader.trail};
      }
      100% {
        box-shadow:
          0 ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE / 2}px transparent,
          ${CELL_SIZE / 2}px ${CELL_SIZE}px transparent,
          0px ${CELL_SIZE}px transparent;
      }
    }

    @keyframes animloader2 {
      0% {
        transform: translate(0, 0);
      }
      25% {
        transform: translate(100%, 0);
      }
      50% {
        transform: translate(100%, 100%);
      }
      75% {
        transform: translate(0, 100%);
      }
      100% {
        transform: translate(0, 0);
      }
    }
  `};
`;
